import React from "react";
import styles from "./Price.module.css";

const services = [
  {
    name: "Sezonowa wymiana opon",
    desc: "",
    price: ""
  },
  {
    name: "Wymiana jednej opony",
    desc: "Wymiana pojedynczej opony w przypadku przebicia",
    price: "80 zł"
  },
  {
    name: "Wyważanie kół",
    desc: "Precyzyjne wyważanie kół dla lepszej jazdy",
    price: "25 zł/koło = 100 zł/komplet"
  },
  {
    name: "Naprawa opony",
    desc:
      "Naprawa opony poprzez klejenie lub zalepianie przebicia, montaż łatki",
    price: "50 zł/opona"
  },
  {
    name: "Wymiana wentyla/czujnika TPMS",
    desc: "Wymiana uszkodzonego wentyla lub czujnika TPMS",
    price: "50 zł/opona"
  },
  {
    name: "Przechowywanie opon",
    desc: [
      "Przechowywanie kompletu opon przez sezon. Jako sezon rozumie się okres 6 miesięcy (zimowy lub letni).",
      "Sezon zimowy trwa od 1 listopada do 30 kwietnia.",
      "Sezon letni trwa od 1 maja do 31 października.",
      "Usługa obejmuje magazynowanie opon w odpowiednich warunkach.",
      "W przypadku braku opłat za następny sezon zostanie naliczana dodatkowa opłata w wysokości 5 zł za oponę za każdy rozpoczęty dzień przechowywania."
    ],
    price: "400 zł/komplet"
  }
];

export default function Price() {
  return (
    <section className="lightSectionContent" id="price">
      <div className="darkSectionTitle">
        <h1>Cennik usług</h1>
      </div>

      <div className={`${styles.wrapper} ${styles.desktopOnly}`}>
        <table className={styles.table}>
          <thead>
            <tr>
              <th>Usługa</th>
              <th>Opis</th>
              <th>Cena</th>
            </tr>
          </thead>

          <tbody>
            {services.map((s, i) =>
              <tr key={i}>
                <td>
                  {s.name}
                </td>
                <td>
                  {i === 0
                    ? <div style={{ display: "flex", gap: "20px" }}>
                        {/* Pierwsza tabela */}
                        <div className={styles.maxTableGroup}>
                          <table className={styles.maxTable}>
                            <thead>
                              <tr>
                                <th colSpan={2}>Felgi stalowe</th>
                                {/* <th></th> */}
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>13-16"</td>
                                <td>140zł</td>
                              </tr>
                              <tr>
                                <td>17-18"</td>
                                <td>160zł</td>
                              </tr>
                              <tr>
                                <td>19-20"</td>
                                <td>180zł</td>
                              </tr>
                              <tr>
                                <td>21-22"</td>
                                <td>220zł</td>
                              </tr>
                            </tbody>
                          </table>

                          {/* Druga tabela */}
                          <table className={styles.maxTable}>
                            <thead>
                              <tr>
                                <th colSpan={2}>Alu Felgi</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>13-16"</td>
                                <td>160zł</td>
                              </tr>
                              <tr>
                                <td>17-18"</td>
                                <td>200zł</td>
                              </tr>
                              <tr>
                                <td>19-20"</td>
                                <td>220zł</td>
                              </tr>
                              <tr>
                                <td>21-22"</td>
                                <td>260zł</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    : Array.isArray(s.desc)
                      ? <ul>
                          {s.desc.map((d, idx) =>
                            <li key={idx}>
                              {d}
                            </li>
                          )}
                        </ul>
                      : s.desc}
                </td>
                <td>
                  {s.price}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <div className={`${styles.mobileOnly}`}>
        {services.map((s, i) =>
          <div key={i} className={styles.card}>
            <h3>
              {s.name}
            </h3>

            {i === 0
              ? <div style={{ display: "flex", gap: "10px", flexWrap: "wrap" }}>
                  {/* Pierwsza tabela */}
                  <div className={styles.miniTableGroup}>
                    <table className={styles.miniTable}>
                      <thead>
                        <tr>
                          <th colSpan={2}>Felgi stalowe</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>13-16"</td>
                          <td>140zł</td>
                        </tr>
                        <tr>
                          <td>17-18"</td>
                          <td>160zł</td>
                        </tr>
                        <tr>
                          <td>19-20"</td>
                          <td>180zł</td>
                        </tr>
                        <tr>
                          <td>21-22"</td>
                          <td>220zł</td>
                        </tr>
                      </tbody>
                    </table>

                    <table className={styles.miniTable}>
                      <thead>
                        <tr>
                          <th colSpan={2}>Alu Felgi</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td>13-16"</td>
                          <td>160zł</td>
                        </tr>
                        <tr>
                          <td>17-18"</td>
                          <td>200zł</td>
                        </tr>
                        <tr>
                          <td>19-20"</td>
                          <td>220zł</td>
                        </tr>
                        <tr>
                          <td>21-22"</td>
                          <td>260zł</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              : Array.isArray(s.desc)
                ? <ul>
                    {s.desc.map((d, j) =>
                      <li key={j}>
                        {d}
                      </li>
                    )}
                  </ul>
                : <ul>
                    <li>
                      {s.desc}
                    </li>
                  </ul>}

            <p className={styles.price}>
              {s.price}
            </p>
          </div>
        )}
      </div>
    </section>
  );
}
